import { render, staticRenderFns } from "./6-gang-zungui.vue?vue&type=template&id=1eb4a75f&scoped=true&"
import script from "./6-gang-zungui.vue?vue&type=script&lang=js&"
export * from "./6-gang-zungui.vue?vue&type=script&lang=js&"
import style0 from "./6-gang-zungui.vue?vue&type=style&index=0&id=1eb4a75f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb4a75f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eb4a75f')) {
      api.createRecord('1eb4a75f', component.options)
    } else {
      api.reload('1eb4a75f', component.options)
    }
    module.hot.accept("./6-gang-zungui.vue?vue&type=template&id=1eb4a75f&scoped=true&", function () {
      api.rerender('1eb4a75f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/6-gang-zungui.vue"
export default component.exports